import { defineMessages } from "react-intl";

export const taxesMessages = defineMessages({
  taxClass: {
    id: "bDBiac",
    defaultMessage: "Tax class",
    description: "dropdown or column label",
  },
  channelsSection: {
    id: "b2DlTO",
    defaultMessage: "Channels",
    description: "Taxes section title",
  },
  countriesSection: {
    id: "ZAaXfz",
    defaultMessage: "Countries",
    description: "Taxes section title",
  },
  taxClassesSection: {
    id: "aJm/by",
    defaultMessage: "Tax classes",
    description: "Taxes section title",
  },
  channelList: {
    id: "yLfbSh",
    defaultMessage: "Channel name",
    description: "support label",
  },
  defaultSettings: {
    id: "pWClYm",
    defaultMessage: "Default settings",
    description: "card title",
  },
  countryExceptions: {
    id: "+2VydL",
    defaultMessage: "Country exceptions",
    description: "card title",
  },
  enteredPrices: {
    id: "puRlnN",
    defaultMessage: "Entered prices",
    description: "card subtitle",
  },
  renderedPrices: {
    id: "98Nw4g",
    defaultMessage: "Rendered prices",
    description: "card subtitle",
  },
  chargeTaxes: {
    id: "EYkW1J",
    defaultMessage: "Charge taxes for this channel",
    description: "checkbox label",
  },
  pricesWithTaxLabel: {
    id: "cVjewM",
    defaultMessage: "Product prices are entered with tax",
    description: "label for radio button",
  },
  pricesWithoutTaxLabel: {
    id: "QpBqa9",
    defaultMessage: "Product prices are entered without tax",
    description: "label for radio button",
  },
  addCountryLabel: {
    id: "/5r4he",
    defaultMessage: "Add country",
    description: "label for button",
  },
  countryNameHeader: {
    id: "D5Wtf/",
    defaultMessage: "Country name",
    description: "table header column",
  },
  chargeTaxesHeader: {
    id: "kXqn6A",
    defaultMessage: "Charge taxes",
    description: "table header column",
  },
  showGrossHeader: {
    id: "skklRz",
    defaultMessage: "Show gross prices in storefront",
    description: "table header column",
  },
  countryList: {
    id: "CFT171",
    defaultMessage: "Country list",
    description: "card header title",
  },
  taxClassRatesHeader: {
    id: "WIxSDm",
    defaultMessage: "{country} class rates",
    description: "card header",
  },
  searchTaxClasses: {
    id: "Ww69SE",
    defaultMessage: "Search tax classes",
    description: "search input placeholder",
  },
  taxNameHeader: {
    id: "qbcNjQ",
    defaultMessage: "Tax name",
    description: "table header column",
  },
  taxRateHeader: {
    id: "Nj9iSB",
    defaultMessage: "Tax rate",
    description: "table header column",
  },
  generalInformation: {
    id: "TfzIXS",
    defaultMessage: "General information",
    description: "tax classes card header",
  },
  taxRateName: {
    id: "720c51",
    defaultMessage: "Tax rate name",
    description: "tax classes name input placeholder",
  },
  taxClassRates: {
    id: "RqtZQ6",
    defaultMessage: "Tax class rates",
    description: "tax classes card header",
  },
  taxClassList: {
    id: "jMzyU8",
    defaultMessage: "Tax classes",
    description: "tax classes card header",
  },
  addTaxClassLabel: {
    id: "NlEVVT",
    defaultMessage: "Create class",
    description: "label for button",
  },
  taxClassNameHeader: {
    id: "/ILyIf",
    defaultMessage: "Tax class label",
    description: "tax classes menu header",
  },
  noExceptionsForChannel: {
    id: "u34css",
    defaultMessage: "There are no exceptions for this channel",
    description: "label for empty list in channels list",
  },
  chooseCountryDialogTitle: {
    id: "0V1q0d",
    defaultMessage: "Choose country you want to add",
    description: "add country dialog header",
  },
  country: {
    id: "UBuKZ9",
    defaultMessage: "Country",
    description: "searchbar placeholder",
  },
  noCountriesAssigned: {
    id: "0a0fLZ",
    defaultMessage: "There are no countries assigned",
    description: "countries list menu label when no countries are assigned",
  },
  addCountryToAccessClass: {
    id: "7U/NPm",
    defaultMessage: "Add country to access tax classes",
    description: "tax class rates list label when no country is selected",
  },
  countryDefaultRate: {
    id: "lnteBJ",
    defaultMessage: "Country default rate",
    description: "country rates list label for the default rate",
  },
  noRatesInTaxClass: {
    id: "ngAgBy",
    defaultMessage:
      "There are no countries using this tax class yet, use {tab} tab to assign tax rates.",
    description: "tax class rates list label when no countries are assigned",
  },
  newTaxClass: {
    id: "8BBMRj",
    defaultMessage: "New tax class",
    description: "default tax class name for new tax classes",
  },
  taxStrategyTaxApp: {
    id: "TJ7WHA",
    defaultMessage: "Use tax app",
    description: "tax strategy combobox choice",
  },
  taxStrategyFlatRates: {
    id: "4p3bjX",
    defaultMessage: "Use flat rates",
    description: "tax strategy combobox choice",
  },
  taxStrategyHint: {
    id: "6HHPFy",
    defaultMessage: "Select the method of tax calculation",
    description: "tax strategy combobox hint",
  },
  noTaxClasses: {
    id: "Rfk+8B",
    defaultMessage: "There are no tax classes",
    description: "tax classes menu label when there are no tax classes",
  },
});
